import { css } from 'linaria';

export const orderStepsSection = css`
  && {
    @media (--only-desktop) {
      margin-bottom: 80px;
    }
  }
`;

export const orderStepsList = css`
  display: grid;
  grid-template-columns: repeat(4, 277px);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-desktop) {
    grid-template-columns: repeat(4, 217px);
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 322px);
    column-gap: 16px;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
    row-gap: 24px;
  }
`;

export const orderStepImage = css`
  display: block;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  object-fit: contain;
`;

export const orderStepName = css`
  margin-bottom: 8px;
`;
